import CustomSlider from './custom_sliderder';

export default (CustomSlider);
